export default {
  gotoGithub: 'GitHub Seite öffnen',
  tab: {
    about: 'Über uns',
    coding: 'Programmierung',
    home: 'Start',
    throbax: {
      title: 'Throbax TD',
      index: 'Übersicht',
      screenShots: 'Bildschirmfotos'
    },
    code: {
      title: 'Freier Code',
      explanation: 'Code Start',
      coding: 'Hilf mit Entwickeln',
      git: 'Git Cheat-Sheet',
      cs: 'Freie C# Libraries',
      java: 'Freie Java Libraries'
    },
    cheatSheets: 'CheatSheets'
  }
}
